import SystemFieldProto from '../../proto/system-field-proto';

import ListComponent from './components/comments-list';
import ViewComponent from './components/comments-view';

//projects only field
export default class CommentsField extends SystemFieldProto {

    constructor(entityType) {
        super(entityType);
        this.type = gd.const.fields.type.COMMENTS;
    }

    get sortHintMessage() {
        return 'Sort by comments';
    }

    getCsvValue(item) {
        return item.statusComments;
    }

    listItemSortFunctions(sort) {
        return {
            functions: [i => i.item.statusComments],
            directions: [sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null);
    }

    get ViewComponent() {
        return ViewComponent.bind(null);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return value?value.trim():null;
    }

    getComponentViewInImport() {
        return SystemFieldUserViewInImport;
    }
}